<template>
	<div>
		<div class="title-container">
			<div class="title">
				Authorized Users
				<div class="subtitle"><span class="fa fa-globe"></span>{{ currentAccount.name }}</div>
			</div>
			<div class="buttons">
				<router-link to="/account/users/create" class="button"><div class="hover-title">Add User</div><span class="fa fa-plus"></span></router-link>
			</div>
		</div>

		<loading v-if="loading && users.length === 0"></loading>

		<div v-if="init" class="table-scroll-wrapper">
			<nothing-here v-if="!loading && activeOrPendingUsers.length === 0" text="No Authorized Users Yet"></nothing-here>
			<div class="table list">
				<div v-if="activeOrPendingUsers.length > 0" class="row">
					<div class="cell"></div>
					<div class="cell">Name or Invitee</div>
					<div class="cell">Access Level</div>
					<div class="cell">Status</div>
				</div>
				<connected-user-item v-for="user in activeOrPendingUsers" :key="`user-${ user.id }`" :user="user" @changed="(u) => updateUser(u)"></connected-user-item>
			</div>
		</div>

		<div v-if="formerlyAuthorizedUsers.length > 0" class="table-scroll-wrapper">
			<div class="title-container">
				<div class="title">Inactive Users</div>
			</div>

			<div v-if="init">
				<div class="table list">
					<div class="row">
						<div class="cell"></div>
						<div class="cell">Name</div>
						<div class="cell">Access Granted To</div>
						<div class="cell">Status</div>
					</div>
					<connected-user-item v-for="user in formerlyAuthorizedUsers" :key="`user-${ user.id }`" :user="user" @changed="(u) => updateUser(u)"></connected-user-item>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import _ from 'underscore';
import { mapGetters } from 'vuex';
import ConnectedUserItem from './components/ConnectedUserItem';

export default {

	name: 'UsersOverviewPage',

	data() {
		return {
			init: false,
			loading: true,
			users: [],
		};
	},

	computed: {

		...mapGetters([ 'currentUser', 'currentAccount', 'canManageUsers', ]),

		activeOrPendingUsers() {
			return this.users.filter(user => [ 'ACTIVE', 'INVITED' ].includes(user.access.status));
		},

		formerlyAuthorizedUsers() {
			return this.users.filter(user => ![ 'ACTIVE', 'INVITED' ].includes(user.access.status));
		},
	},

	created() {
		if (!this.canManageUsers) {
			this.$store.dispatch('addToast', { message: 'Access Denied', type: 'bad-bg' });
			return this.$router.replace('/dashboard');
		}

		this.loadUsers();
	},

	methods: {

		async loadUsers() {
			if (this.loading && this.init) return;

			this.loading = true;

			try {
				const { data } = await this.$api.get('/account/connections');

				this.users = data.data;
			} catch (e) {
				this.$store.dispatch('addToast', { message: 'Unable to load users', type: 'bad-bg' });
			}

			this.init = true;
			this.loading = false;
		},

		updateUser(user) {
			const index = _.findIndex(this.users, {id: user.id });
			if (index !== false) {
				this.$set(this.users, index, user);
			}

			this.loadUsers();
		}
	},

	components: {
		ConnectedUserItem,
	},
};

</script>
